import { KAPLAYCtx } from "kaplay";

function load_sprites(k: KAPLAYCtx) {
  k.loadSpriteAtlas("sprites/objects/cat1.png", {
    cat1: {
      x: 0,
      y: 0,
      width: 32 * 4,
      height: 32 * 13,
      sliceX: 4,
      sliceY: 13,
      anims: {
        walkLeft: { from: 0, to: 3, loop: true, speed: 10 },
        walkForward: { from: 4, to: 7, loop: true, speed: 10 },
        walkBackward: { from: 8, to: 11 },
        sitLeft: { from: 12, to: 15 },
        sitForward: { from: 16, to: 19, speed: 5 },
        lick: { from: 20, to: 23 },
        frolick: { from: 24, to: 27 },
        layForward: { from: 28, to: 31 },
        layBackward: { from: 32, to: 35 },
        sleep: { from: 36, to: 39, loop: true, speed: 2 },
        laySide: { from: 40, to: 43 },
        tongueLaySide: { from: 44, to: 47 },
      },
    },
  });
  k.loadSprite("tutorial_cat", "sprites/furniture/tutorial_cat.png", {
    sliceX: 4,
    anims: {
      open: { from: 0, to: 3, loop: false, speed: 2 },
      close: { from: 3, to: 0, loop: false, speed: 4 }
    }
  });

  k.loadSpriteAtlas("sprites/objects/cat_food_bowl.png", {
    dry_food_bowl: { x: 0, y: 0, width: 16, height: 16 },
    cat_food_dry: { x: 16, y: 0, width: 16, height: 16 },
  });
  k.loadSprite("pumpkin", "sprites/objects/pumpkin.png");
  k.loadSprite("pumpkin_seeds", "sprites/objects/pumpkin_seeds.png");
  k.loadSpriteAtlas("sprites/objects/water.png", {
    water: { x: 16, y: 0, width: 16, height: 16 },
    water_bowl: { x: 0, y: 0, width: 16, height: 16 },
  });
  k.loadSpriteAtlas("sprites/objects/cat_food_wet.png", {
    cat_food_wet: { x: 16, y: 0, width: 16, height: 16 },
    wet_food_bowl: { x: 0, y: 0, width: 16, height: 16 },
  });
  k.loadSprite("hand_cursor", "sprites/objects/hand_cursor.png");
  k.loadSprite("hand_grab", "sprites/objects/hand_grab.png");
  k.loadSprite("hand_open", "sprites/objects/hand_open.png");
  k.loadSprite("pointer", "sprites/objects/pointer.png");
  k.loadSprite("floor", "sprites/interior/floor.png");
  k.loadSprite("kitchen_floor", "sprites/interior/kitchen_floor.png");
  k.loadSpriteAtlas("sprites/interior/wall2.png", {
    wall_left: {
      x: 0,
      y: 0,
      width: 16,
      height: 32,
    },
    wall_middle: {
      x: 16,
      y: 0,
      width: 16,
      height: 32,
    },
    wall_right: {
      x: 32,
      y: 0,
      width: 16,
      height: 32,
    },
  });
  k.loadSpriteAtlas("sprites/interior/wall_topper.png", {
    wall_topper: {
      x: 0,
      y: 0,
      width: 192,
      height: 64,
      sliceX: 12,
      sliceY: 4,
    },
  });
  let furniture = [
    "bed",
    "bookshelf",
    "calendar",
    "cat_stand",
    "grandfather_clock",
    "lamp",
    "teddy_bear",
    "closet",
    "sofa",
    "fridge",
    "stove",
    "counter",
    "knives",
    "sink",
    "table",
    "flowers",
    "side_table",
    "island",
    "litter_box",
    "cat_tent",
    "phone",
  ];
  for (let i = 0; i < furniture.length; i++) {
    k.loadSprite(furniture[i], "sprites/furniture/" + furniture[i] + ".png");
  }
  k.loadSprite("chairs", "sprites/furniture/chairs.png", { sliceX: 4 });
  k.loadSprite("carpet", "sprites/interior/carpet.png");
  k.loadSprite("text_box", "sprites/dialogue box.png");
  k.loadSprite("arrow_up", "sprites/ui/arrow_up.png");
  k.loadBitmapFont("round", "sprites/round_6x6.png", 6, 6, {
    chars:
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-=()[]{}<>/*:#%!?.,'\"@&$ ",
  });
  k.loadSprite("ground_decor", "sprites/exterior/fall_ground.png", { sliceX: 15 });
  k.loadSprite("ground", "sprites/exterior/ground_tileset_water.png", { sliceX: 12, sliceY: 4 });
  k.loadSprite("roads", "sprites/exterior/roads.png", { sliceX: 3, sliceY: 4 });
  k.loadSprite("well", "sprites/exterior/well.png", { sliceX: 4, anims: { run: { from: 0, to: 3, loop: true, pingpong: true, speed: 4 } } });
  k.loadSprite("house", "sprites/exterior/house2.png");
  k.loadSprite("maple_small", "sprites/exterior/maple_small.png");
  k.loadSprite("maple_large", "sprites/exterior/maple_large.png");
  k.loadSprite("bubbles", "sprites/exterior/bubbles.png", { sliceX: 7, anims: { bubble: { from: 0, to: 6, loop: true } } });
  k.loadSprite("picky_kitty", "sprites/exterior/picky_kitty.png");
}

export default load_sprites;
